module.exports = __webpack_public_path__ + "img/logo.5694dd42.svg";